import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import elTranslations from './locales/el.json';
import enTranslations from './locales/en.json';

const resources = {
  el: { translation: elTranslations },
  en: { translation: enTranslations }
};

const defaultLng =
  typeof window !== 'undefined' && window.location.pathname.startsWith('/en')
    ? 'en'
    : 'el';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export const loadLanguage = async (lng: 'el' | 'en') => {
  await i18n.changeLanguage(lng);
};

export default i18n;

